// ============================================================================
// ADIS 95 - Category Catalog Data
// Extracted from SiteOne Crawler offline export of adis95.fr
// ============================================================================

export interface BrandSubcategory {
  slug: string
  name: string
  description: string
  productCount: number
  logoUrl?: string
}

export interface Category {
  slug: string
  name: string
  heading: string
  parentBreadcrumb: string
  brands: BrandSubcategory[]
}

export const categories: Category[] = [
  {
    slug: "abrasifs",
    name: "Abrasifs",
    heading:
      "Nous avons choisi les produits les plus performants du marche :",
    parentBreadcrumb: "Outillage",
    brands: [
      {
        slug: "abrasifs-cemon-ekamant",
        name: "Abrasifs - Cemon Ekamant",
        description: "L'abrasif Suedois specialise dans le bois.",
        productCount: 1,
        logoUrl:
          "/images/remote/Logo-EKAMANT1-300x300.jpg",
      },
      {
        slug: "abrasifs-sia-abrasif",
        name: "Abrasifs - Sia abrasif",
        description:
          "Fabrication Suisse, une solution pour chaque materiaux.",
        productCount: 1,
        logoUrl:
          "/images/remote/SIA-logo-300x300.jpg",
      },
    ],
  },
  {
    slug: "compresseurs",
    name: "Compresseurs",
    heading:
      "Nous avons choisi de travailler avec des marques de renom :",
    parentBreadcrumb: "Outillage",
    brands: [
      {
        slug: "compresseurs-abac",
        name: "Compresseurs - Abac",
        description:
          "Fabricant Italien pour le grand public, professionnel et industriel.",
        productCount: 1,
      },
      {
        slug: "compresseurs-guernet",
        name: "Compresseurs - Guernet",
        description: "Fabricant Francais pour l'industrie.",
        productCount: 1,
      },
    ],
  },
  {
    slug: "electroportatifs",
    name: "Electroportatifs",
    heading:
      "Nous avons choisi de travailler avec les leaders du marche :",
    parentBreadcrumb: "Outillage",
    brands: [
      {
        slug: "electroportatifs-festool",
        name: "Electroportatifs - Festool",
        description: "Leader dans le travail du bois.",
        productCount: 1,
      },
      {
        slug: "electroportatifs-makita",
        name: "Electroportatifs Makita",
        description: "Fabricant generaliste.",
        productCount: 1,
      },
      {
        slug: "electroportatifs-lamello",
        name: "Electroportatifs Lamello",
        description: "Specialiste Suisse de l'assemblage.",
        productCount: 1,
      },
      {
        slug: "electroportatifs-virutex",
        name: "Electroportatifs Virutex",
        description: "Fabricant d'outillage specifique.",
        productCount: 1,
      },
      {
        slug: "electroportatifs-fein",
        name: "Electroportatifs Fein",
        description: "Leader dans le travail du metal.",
        productCount: 1,
      },
      {
        slug: "electroportatifs-alsafix",
        name: "Electroportatifs Alsafix",
        description:
          "Fabricant Alsacien des cloueurs et agrafeuses.",
        productCount: 1,
      },
      {
        slug: "electroportatifs-kyocera-senco",
        name: "Electroportatifs Kyocera - Senco",
        description:
          "Fabricant Vosgienne des cloueurs et agrafeuses.",
        productCount: 1,
      },
      {
        slug: "electroportatifs-kmr",
        name: "Electroportatifs KMR",
        description:
          "Fabricant Allemand des cloueurs et agrafeuses.",
        productCount: 1,
      },
    ],
  },
  {
    slug: "fers-et-plaquettes",
    name: "Fers et plaquettes",
    heading:
      "Nous avons choisi les produits les plus performants du marche :",
    parentBreadcrumb: "Outillage",
    brands: [
      {
        slug: "fers-et-plaquettes-ceratizit",
        name: "Fers et plaquettes - Ceratizit",
        description:
          "Un des plus grand producteur mondial des produits en carbure.",
        productCount: 1,
      },
      {
        slug: "fers-et-plaquettes-jaguar",
        name: "Fers et plaquettes - Jaguar",
        description: "Fabricant Francais.",
        productCount: 1,
      },
      {
        slug: "fers-et-plaquettes-leman",
        name: "Fers et plaquettes Leman",
        description: "Importateur europeen.",
        productCount: 1,
      },
    ],
  },
  {
    slug: "fraises-scie",
    name: "Fraises scie",
    heading:
      "Nous avons choisi de travailler avec le fabricant le plus performant :",
    parentBreadcrumb: "Outillage",
    brands: [
      {
        slug: "fraises-scie-sdc-julia",
        name: "Fraises scie - SDC Julia",
        description:
          "Fabrication Italienne standard et sur mesure.",
        productCount: 1,
      },
    ],
  },
  {
    slug: "lames-circulaires-acier",
    name: "Lames circulaires acier",
    heading:
      "Nous avons choisi de travailler avec des fabricants francais :",
    parentBreadcrumb: "Outillage",
    brands: [
      {
        slug: "lames-circulaires-acier-jaguar",
        name: "Lames circulaires acier - Jaguar",
        description: "Fabricant Francais.",
        productCount: 1,
      },
      {
        slug: "lames-circulaires-acier-mfls-forezienne",
        name: "Lames circulaires acier - MFLS Forezienne",
        description: "Fabricant Francais.",
        productCount: 1,
      },
    ],
  },
  {
    slug: "lames-circulaires-carbure",
    name: "Lames circulaires carbure",
    heading:
      "Nous avons choisi de travailler avec les fabricants europeens les plus performants :",
    parentBreadcrumb: "Outillage",
    brands: [
      {
        slug: "lames-circulaires-carbure-ake",
        name: "Lames circulaires carbure - AKE",
        description:
          "Fabricant allemand outillage haute gamme.",
        productCount: 2,
      },
      {
        slug: "lames-circulaires-carbure-jaguar",
        name: "Lames circulaires carbure - Jaguar",
        description: "Specialiste des outils de sciage.",
        productCount: 1,
      },
      {
        slug: "lames-circulaires-carbure-mfls-forezienne",
        name: "Lames circulaires carbure - MFLS Forezienne",
        description:
          "Fabricant francais specialise dans l'outillage coupant.",
        productCount: 1,
      },
    ],
  },
  {
    slug: "machines-datelier-bois-et-metal",
    name: "Machines d'atelier bois et metal",
    heading:
      "Nous avons choisi un fournisseur ayant une large gamme de produits :",
    parentBreadcrumb: "Outillage",
    brands: [
      {
        slug: "machines-datelier-bois-et-metal-promac",
        name: "Machines d'atelier bois et metal - Promac",
        description: "Fabricant d'equipement d'atelier.",
        productCount: 1,
      },
    ],
  },
  {
    slug: "outillages-bois",
    name: "Outillages Bois",
    heading:
      "Nous avons choisi de travailler avec les leaders du marche :",
    parentBreadcrumb: "Outillage",
    brands: [
      {
        slug: "outillages-bois-ake",
        name: "Outillages Bois - AKE",
        description: "Outils standards et sur mesure.",
        productCount: 1,
      },
      {
        slug: "outillages-bois-cmt",
        name: "Outillages Bois - CMT",
        description: "La marque orange mondialement connue.",
        productCount: 1,
      },
      {
        slug: "outillages-bois-leman",
        name: "Outillages Bois - Leman",
        description:
          "Importateur et repreneur de la marque francaise ISOCELE.",
        productCount: 1,
      },
      {
        slug: "outillages-bois-mfls-forezienne",
        name: "Outillages Bois - MFLS Forezienne",
        description: "Fabricant Francais d'outillage.",
        productCount: 2,
      },
    ],
  },
  {
    slug: "outillages-divers",
    name: "Outillages Divers",
    heading:
      "Nous avons choisi des fournisseurs ayant une large gamme de produits :",
    parentBreadcrumb: "Outillage",
    brands: [
      {
        slug: "outillages-divers-alpha-coupe",
        name: "Outillages Divers - Alpha coupe",
        description: "Specialiste de foret bois/metal/beton.",
        productCount: 1,
      },
      {
        slug: "outillages-divers-jaguar",
        name: "Outillages Divers - Jaguar",
        description: "Fabricant Francais.",
        productCount: 1,
      },
      {
        slug: "outillages-divers-leman",
        name: "Outillages Divers - Leman",
        description: "Importateur europeen.",
        productCount: 1,
      },
      {
        slug: "outillages-divers-mfls-forezienne",
        name: "Outillages Divers - MFLS Forezienne",
        description: "Fabricant Francais.",
        productCount: 1,
      },
    ],
  },
  {
    slug: "rubans",
    name: "Rubans",
    heading:
      "Nous avons choisi de travailler avec des fabricants francais :",
    parentBreadcrumb: "Outillage",
    brands: [
      {
        slug: "rubans-jaguar",
        name: "Rubans - Jaguar",
        description: "Fabricant Francais.",
        productCount: 1,
      },
      {
        slug: "rubans-mfls-forezienne",
        name: "Rubans - MFLS Forezienne",
        description: "Fabricant Francais.",
        productCount: 1,
      },
    ],
  },
  {
    slug: "serrages",
    name: "Serrages",
    heading:
      "Nous avons choisi de travailler avec les leaders du marche :",
    parentBreadcrumb: "Outillage",
    brands: [
      {
        slug: "serrages-leman",
        name: "Serrages - Leman",
        description: "Importateur europeen.",
        productCount: 1,
      },
      {
        slug: "serrages-piher",
        name: "Serrages - Piher",
        description: "Specialiste des outils de serrage.",
        productCount: 1,
      },
    ],
  },
]

// Helper: get category by slug
export function getCategoryBySlug(slug: string): Category | undefined {
  return categories.find((c) => c.slug === slug)
}

// Helper: get all brand names across all categories
export function getAllBrandNames(): string[] {
  const brands = new Set<string>()
  categories.forEach((cat) => {
    cat.brands.forEach((brand) => {
      // Extract just the brand name (after the dash)
      const parts = brand.name.split(" - ")
      brands.add(parts.length > 1 ? parts[1].trim() : brand.name)
    })
  })
  return [...brands].sort()
}

// Helper: total product count for a category
export function getCategoryProductCount(slug: string): number {
  const cat = getCategoryBySlug(slug)
  if (!cat) return 0
  return cat.brands.reduce((sum, b) => sum + b.productCount, 0)
}
